import Vue from 'vue'
import Router from 'vue-router'
import Top from '@/components/Top'
import Book from '@/components/Book'
import Zoom from '@/components/Zoom'
import Sign from '@/components/Sign'
import Event from '@/components/Event'
import EventArchive from '@/components/EventArchive'
import Campaign from '@/components/Campaign'
import CampaignArchive from '@/components/CampaignArchive'
import Trip from '@/components/Trip'
import Currency from '@/components/Currency'
import Dance from '@/components/Dance'
import Introduce from '@/components/Introduce'
import Sekai from '@/components/Sekai'
import Report from '@/components/Report'
import Contact from '@/components/Contact'
import Privacy from '@/components/Privacy'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top
    },
    {
      path: '/ehon.html',
      name: 'Book',
      component: Book
    },
    {
      path: '/how_to_zoom.html',
      name: 'Zoom',
      component: Zoom 
    },
    {
      path: '/about_sign_event.html',
      name: 'Sign',
      component: Sign
    },
    {
      path: '/taiken.html',
      name: 'Event',
      component: Event
    },
    {
      path: '/taiken/archive/:code.html',
      name: 'EventArchive',
      component: EventArchive
    },
    {
      path: '/campaign.html',
      name: 'Campaign',
      component: Campaign
    },
    {
      path: '/campaign/archive/:code.html',
      name: 'CampaignArchive',
      component: CampaignArchive
    },
    {
      path: '/yomikikasetai.html',
      name: 'Trip',
      component: Trip
    },
    {
      path: '/donguri.html',
      name: 'Currency',
      component: Currency
    },
    {
      path: '/dance.html',
      name: 'Dance',
      component: Dance
    },
    {
      path: '/world.html',
      name: 'Seaki',
      component: Sekai
    },
    {
      path: '/introduce.html',
      name: 'Introduce',
      component: Introduce
    },
    {
      path: '/houkoku.html',
      name: 'Report',
      component: Report
    },
    {
      path: '/otoiawase.html',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/privacypolicy.html',
      name: 'Privacy',
      component: Privacy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js